/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Dutch_PassionInputs */

const en_about_dutch_passion = /** @type {(inputs: About_Dutch_PassionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Dutch Passion`)
};

const th_about_dutch_passion = /** @type {(inputs: About_Dutch_PassionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกี่ยวกับ Dutch Passion`)
};

const ja_about_dutch_passion = /** @type {(inputs: About_Dutch_PassionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dutch Passion について`)
};

const fr_about_dutch_passion = /** @type {(inputs: About_Dutch_PassionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos de Dutch Passion`)
};

const es_about_dutch_passion = /** @type {(inputs: About_Dutch_PassionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre Dutch Passion`)
};

const ru_about_dutch_passion = /** @type {(inputs: About_Dutch_PassionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О Dutch Passion`)
};

const zh_about_dutch_passion = /** @type {(inputs: About_Dutch_PassionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于 Dutch Passion`)
};

const vi_about_dutch_passion = /** @type {(inputs: About_Dutch_PassionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về Dutch Passion`)
};

/**
* | output |
* | --- |
* | "About Dutch Passion" |
*
* @param {About_Dutch_PassionInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const about_dutch_passion = /** @type {((inputs?: About_Dutch_PassionInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Dutch_PassionInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_about_dutch_passion(inputs)
	if (locale === "ja") return ja_about_dutch_passion(inputs)
	if (locale === "fr") return fr_about_dutch_passion(inputs)
	if (locale === "es") return es_about_dutch_passion(inputs)
	if (locale === "ru") return ru_about_dutch_passion(inputs)
	if (locale === "zh") return zh_about_dutch_passion(inputs)
	if (locale === "vi") return vi_about_dutch_passion(inputs)
	return en_about_dutch_passion(inputs)
});